//
import COMMON from './modules/common/index';
import USER from './modules/user/index';
import REGION from './modules/region/index';
import DATAMANAGEMENT from './modules/dataManagement/index';
import MENU from './modules/menu/index';
import ROLE from './modules/role/index';
import ORG from './modules/org/index';
import STORE from './modules/store/index';
import NEWMANAGEMENT from './modules/newManagement/index';
import TEMPLATE from './modules/template/index';
import USERMANAGEMENT from './modules/userManagement/index';
import PLATFROM from './modules/platform/index';
import CUSTOMERSERVICE from './modules/customerService/index';
import ABOUTJCN from './modules/aboutJcn/index';
import CONTACT from './modules/contact/index';
import SLIDE from './modules/slide/index';
import BUSINESS from './modules/business/index';
import PRODUCT from './modules/product/index';
import VIDEOAREA from './modules/videoArea/index';
import SOLUTION from './modules/solution/index';
import SOLUTIONFT from './modules/solution-ft/index';
import DOWNLOAD from './modules/download/index';
//
const apiUrl = { COMMON, USER, REGION, DATAMANAGEMENT, MENU, ROLE, STORE, ORG, NEWMANAGEMENT, TEMPLATE, USERMANAGEMENT, PLATFROM, CUSTOMERSERVICE, ABOUTJCN, CONTACT, SLIDE, PRODUCT, VIDEOAREA, BUSINESS, SOLUTION, SOLUTIONFT, DOWNLOAD };
export default {
  install(Vue) {
    Vue.prototype.$apiUrl = apiUrl;
    Vue.apiUrl = apiUrl;
  }
}



// WEBPACK FOOTER //
// ./src/data/apiUrl/index.js